// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"153bde94","221":"72b5d449","276":"bf58d212"}[chunkId] + ".chunk.js";
};